import { gql } from "@apollo/client";

const GET_FAQ_GNS_DATA = gql`
  query getFaqData {
    getUscFaq(filter: { status: { eq: true } }, sort: { sort_order: ASC }) {
      faq_id
      status
      store_view
      question
      answer
      sort_order
      created_at
      updated_at
    }
  }
`;

export default GET_FAQ_GNS_DATA;
